import { Link } from "react-router-dom";
import { RotateCcw, BadgeCheck, Ban, RefreshCcw, Phone } from "lucide-react";

const SECTIONS = [
  {
    icon: BadgeCheck, title: "Return eligibility",
    points: [
      "Non-personalized gifts can be returned within 7 days of delivery if unused and in original packaging.",
      "Personalized products (custom mugs, photo frames, cushions, engraved keepsakes) are made uniquely for you and cannot be returned or exchanged — except when damaged, defective or incorrect.",
      "Perishable and made-to-order items are eligible for replacement only when they arrive damaged.",
    ],
  },
  {
    icon: RefreshCcw, title: "Damaged or wrong product?",
    points: [
      "Take a clear photo of the item and packaging within 24 hours of delivery.",
      "Email it to customizegiftonline@gmail.com or call 9899534126 with your Order ID.",
      "We arrange a free replacement or a full refund — your choice. No courier hassles for damaged personalized items.",
    ],
  },
  {
    icon: Ban, title: "Cancellations",
    points: [
      "Orders can be cancelled free of charge any time before they are shipped.",
      "Personalized gifts that have entered production (printing/engraving started) cannot be cancelled.",
      "To cancel, contact support with your Order ID as early as possible.",
    ],
  },
  {
    icon: RotateCcw, title: "Refund processing",
    points: [
      "Approved refunds are processed within 5–7 business days.",
      "Online payments are refunded to the original payment method; COD orders are refunded via bank transfer or UPI.",
      "You'll receive a confirmation once the refund is initiated. (Editable placeholder — update with final policy terms.)",
    ],
  },
];

export default function ReturnsRefundsPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid="returns-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B45309]">Customer Support</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-stone-900 mt-3 tracking-tight">Returns & Refunds</h1>
      <p className="text-stone-500 mt-2 max-w-xl">Fair, simple and human. Here's exactly how returns, replacements and refunds work at Customize Gift Online.</p>

      <div className="space-y-4 mt-10">
        {SECTIONS.map((s) => (
          <div key={s.title} className="p-6 rounded-2xl bg-white border border-[#E9E2D7]" data-testid={`returns-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-xl bg-[#F5EFE6] grid place-items-center"><s.icon size={18} className="text-[#B45309]" /></span>
              <h2 className="font-serif text-xl font-bold text-stone-900">{s.title}</h2>
            </div>
            <ul className="mt-4 space-y-2.5">
              {s.points.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-stone-600 leading-relaxed">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E0A96D] mt-2 shrink-0" /> {p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-10 p-6 rounded-2xl bg-[#1C1917] text-[#FDFBF7] flex flex-col sm:flex-row sm:items-center gap-4">
        <Phone size={22} className="text-[#E0A96D] shrink-0" />
        <div className="flex-1">
          <p className="font-serif text-lg font-bold">Need a hand with a return?</p>
          <p className="text-sm text-stone-400 mt-1">customizegiftonline@gmail.com · 9899534126 · Mon–Sat, 9am–9pm IST</p>
        </div>
        <Link to="/contact" className="shrink-0 px-6 h-11 rounded-full bg-[#B45309] text-white text-sm font-bold grid place-items-center hover:bg-[#92400E] transition-colors" data-testid="returns-contact-cta">Contact Support</Link>
      </div>
    </div>
  );
}
